// components/Auth/RegistrationWizard/Step1EmailVerification.jsx
import React, { useState } from 'react';
import Button from '../ui/Button';
import {  auth, db, storage, firestore } from '../../firebase/firebase';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { useTranslation } from 'react-i18next';
import styles from './Step1EmailVerification.module.css';
import { sendSignInLinkToEmail, fetchSignInMethodsForEmail  } from 'firebase/auth';

const Step1EmailVerification = ({ nextStep, setFormData }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { notify } = useNotifications();
  const actionCodeSettings = {
    url: window.location.origin + '/complete-registration',
    handleCodeInApp: true,
  };

  const handleSendLink = async (e) => {
    e.preventDefault();
    setLoading(true);

	if(email.length == 0) {
		notify('error', "No email!?");
		return;
	}
    try {
      // 1?? Check if user already exists
      const methods = await fetchSignInMethodsForEmail(auth, email);
      if (methods.length > 0) {
        notify('error', t('verification.alreadyRegistered'));
        setLoading(false);
        return;
      }

      // 2?? Check if we've already sent verification email (optional)
      if (false && window.localStorage.getItem(`emailverificationSent:${email}`)) {
        //notify('info', t('verification.alreadySent'));
        setLoading(false);
		setFormData(prev => ({ ...prev, email }));
		nextStep();
        return;
      }

      // 3?? Send sign-in link
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('emailForSignIn', email);
      window.localStorage.setItem(`emailverificationSent:${email}`, 'true');
      notify('success', t('verification.emailSent'));

    } catch (err) {
      console.error(err);
      notify('error', err.message);
    }

    setLoading(false);
  };

  const handleSendLinkold = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('emailForSignIn', email);
      notify('success', t('verification.emailSent'));
    } catch (err) {
      console.error(err);
      notify('error', err.message);
    }
    setLoading(false);
  };

  return (
    <div className={styles.stepContainer}>
      <h2 className={styles.stepTitle}>Verify Your Email</h2>
      <input className={styles.inputField}
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required />
		
      <div className={styles.notice}><p>We'll send a verification link to this address.</p></div>
      <Button variant="primary" onClick={handleSendLink}>Send Verification Link</Button>
    </div>
  );
};

export default Step1EmailVerification;
